import { SET_REPAIR_COMMENTS } from 'actions';

export function setRepairComments(repairComments: string) {
  return { repairComments, type: SET_REPAIR_COMMENTS };
}
